import { useState, type FormEvent } from "react";

type Status = "idle" | "sending" | "done" | "error";

export function NotifyForm() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState("");

  async function submit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (status === "sending") return;
    setStatus("sending");
    setError("");
    try {
      const res = await fetch("/api/notify", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ email }),
      });
      const data = (await res.json()) as { ok?: boolean; error?: string };
      if (!res.ok || !data.ok) throw new Error(data.error || "Something went wrong. Try again.");
      setStatus("done");
    } catch (err) {
      setStatus("error");
      setError(err instanceof Error ? err.message : "Something went wrong. Try again.");
    }
  }

  if (status === "done") {
    return (
      <p className="mt-10 rounded-full border border-lilac/40 bg-lilac/15 px-[22px] py-3.5 text-[15px] text-white">
        You're on the list. We'll email you at launch.
      </p>
    );
  }

  return (
    <div className="mt-10 w-full max-w-[420px]">
      <form
        onSubmit={submit}
        className="pointer-events-auto flex gap-2 rounded-full border border-white/10 bg-[#201c2e]/90 p-1.5 backdrop-blur-sm transition-colors focus-within:border-lilac/50"
      >
        <label className="sr-only" htmlFor="notify-email">
          Email address
        </label>
        <input
          id="notify-email"
          type="email"
          required
          autoComplete="email"
          placeholder="you@example.com"
          value={email}
          onChange={e => setEmail(e.target.value)}
          aria-invalid={status === "error"}
          className="min-w-0 flex-1 bg-transparent px-3.5 text-[15px] text-white outline-none placeholder:text-[#7a7390]"
        />
        <button
          type="submit"
          disabled={status === "sending"}
          className="cursor-pointer rounded-full bg-lilac px-5 py-3 text-sm font-semibold text-ink transition-colors hover:bg-white disabled:cursor-wait disabled:opacity-70"
        >
          {status === "sending" ? "Adding…" : "Notify me"}
        </button>
      </form>
      <p aria-live="polite" className="min-h-5 pt-2.5 text-[13px] text-[#ff9db0]">
        {error}
      </p>
    </div>
  );
}

export default NotifyForm;
